import { ReactNode, useEffect, useRef } from "react"
import cn from "classnames"
import { createPortal } from "react-dom"

import style from "ui-kit/components-branded/Modal/style.module.scss"
import { Content } from "ui-kit/components-branded/Modal/Content"
import { MODAL_THEMES, ModalTheme } from "ui-kit/components-branded/Modal/contants"
import { useIsSSR } from "utils/hooks/useIsSSR"

interface ModalProps {
    onBackgroundClick?: () => void
    rememberScroll?: boolean
    isActive?: boolean
    children: ReactNode
    className?: string
    theme?: ModalTheme
}

export function Modal({
    children,
    onBackgroundClick,
    className,
    isActive,
    rememberScroll,
    theme = MODAL_THEMES.LIGHT,
}: ModalProps) {
    const lastScrollY = useRef(0)
    const isSSR = useIsSSR()

    useEffect(() => {
        if (rememberScroll) {
            if (isActive) {
                lastScrollY.current = window.scrollY
                window.scroll({ top: 0 })
            } else {
                window.scroll({ top: lastScrollY.current })
            }
        }
    }, [isActive])

    useEffect(() => {
        if (isActive) {
            document.body.style.overflow = "hidden"
            document.documentElement.style.overflow = "unset"
        } else {
            document.body.style.removeProperty("overflow")
            document.documentElement.style.removeProperty("overflow")
        }
        return () => {
            document.body.style.removeProperty("overflow")
            document.documentElement.style.removeProperty("overflow")
        }
    }, [isActive])

    return (
        <>
            {!isSSR &&
                createPortal(
                    <>
                        <div
                            className={cn(style.modalBackground, { [style.isActive]: isActive })}
                        />
                        <div
                            className={cn(style.container, {
                                [style.isActive]: isActive,
                            })}
                        >
                            <div className={style.flexCenter}>
                                <div
                                    className={style.fakeBackground}
                                    onClick={onBackgroundClick}
                                ></div>
                                <div className={style.modalMarginWrapper}>
                                    <div
                                        className={cn(
                                            style.blmModal,
                                            className,
                                            {
                                                [style.isActive]: isActive,
                                            },
                                            style[theme?.toLowerCase()]
                                        )}
                                    >
                                        {children}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>,
                    document.body
                )}
        </>
    )
}

Modal.Content = Content
